/**
 * Custom JS to play video in a lightbox
 * Source: https://codepen.io/darcyvoutt/pen/MaamWg
 */

// video lightbox functionality
if(document.getElementsByClassName('hero-video-button').length > 0) {
  document.getElementsByClassName('hero-video-button')[0].addEventListener('click', function() {
    revealVideo('lightbox-video', 'lightbox-video-frame');
  });
}
if(document.getElementsByClassName('lightbox-video').length > 0) {
  document.getElementsByClassName('lightbox-video')[0].addEventListener('click', function() {
    hideVideo('lightbox-video', 'lightbox-video-frame');
  });
}
if(document.getElementsByClassName('lightbox-video-close').length > 0) {
  document.getElementsByClassName('lightbox-video-close')[0].addEventListener('click', function() {
    hideVideo('lightbox-video', 'lightbox-video-frame');
  });
}

// Function to reveal lightbox and adding YouTube autoplay
function revealVideo(div,video_id) {
  var video = document.getElementsByClassName(video_id)[0].src;
  document.getElementsByClassName(video_id)[0].src = video+'&autoplay=1'; // adding autoplay to the URL
  document.getElementsByClassName(div)[0].style.display = 'block';
}

// Hiding the lightbox and removing YouTube autoplay
function hideVideo(div,video_id) {
  var video = document.getElementsByClassName(video_id)[0].src;
  var cleaned = video.replace('&autoplay=1',''); // removing autoplay form url
  document.getElementsByClassName(video_id)[0].src = cleaned;
  document.getElementsByClassName(div)[0].style.display = 'none';
}
